// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"0048a84f","75":"54b8f3ac","379":"f01ed931","501":"f01ed931","551":"1169510c","654":"d8726a19","742":"ae921f9e"}[chunkId] + ".chunk.css";
};